module.exports = __webpack_public_path__ + "static/media/Hermione Granger 2.049be5b0.jpg";